type SizeClass = 'small' | 'medium' | 'large'

export const getSelectStyles = (sizeClass: SizeClass, customSize?: string) => {
    const baseStyles = {
        placeholder: (base: any) => ({
            ...base,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        })
    }

    let controlStyles: any = {}
    let valueContainerStyles: any = {}
    let inputStyles: any = {}
    let singleValueStyles: any = {}
    let dropdownIndicatorStyles: any = {}

    switch (sizeClass) {
        case 'small':
            controlStyles = {
                minHeight: '31px',
                height: '31px',
            }
            valueContainerStyles = {
                padding: '0.35rem 0.25rem',
            }
            inputStyles = {
                fontSize: '0.925rem', // $font-size-sm
                margin: 0,
                padding: 0,
            }
            singleValueStyles = {
                fontSize: '0.925rem', // $font-size-sm
            }
            dropdownIndicatorStyles = {
                padding: '0.35rem 0.05rem',
            }
            break

    }

    return {
        container: (base: any) => ({
            ...base,
            width: customSize ? customSize : sizeClass === 'small' ? 120 : sizeClass === 'medium' ? 150 : 150,
        }),
        control: (base: any) => ({
            ...base,
            ...controlStyles,
        }),
        valueContainer: (base: any) => ({
            ...base,
            ...valueContainerStyles,
        }),
        input: (base: any) => ({
            ...base,
            ...inputStyles,
        }),
        singleValue: (base: any) => ({
            ...base,
            ...singleValueStyles,
        }),
        dropdownIndicator: (base: any) => ({
            ...base,
            ...dropdownIndicatorStyles,
        }),
        ...baseStyles,
    }
}
